<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs">Solicitudes</p>
        <h2 class="">Solicitudes</h2>
    </div>
</div>
<div class="content-block">
    <div class="dx-card responsive-paddings">
        <div class="flex flex-wrap icons-descW mb-3">
            <div class=""><i class="fas fa-project-diagram status-ico"></i> = Dispersión Derivada</div>
            <div class=""><i class="fas fa-exclamation-triangle status-1 status-ico"></i> = Por aprobar</div>
            <div class=""><i class="far fa-check status-2 status-ico"></i> = Aprobada</div>
            <div class=""><i class="fas fa-arrow-right status-6 status-ico"></i> = En proceso</div>
            <div class=""><i class="far fa-check-square status-3 status-ico"></i> = Completada</div>
            <div class=""><i class="fas fa-times status-4 status-ico"></i> = Error</div>
            <div class=""><i class="fas fa-ban status-5 status-ico"></i> = Cancelada</div>
        </div>
        <dx-data-grid [dataSource]="dispersions" keyExpr="id" [showBorders]="true"
            [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }">
            <dxo-load-panel [enabled]="true"></dxo-load-panel>  
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
            </dxo-pager>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <!-- <dxo-editing mode="batch" [allowUpdating]="true" [selectTextOnEditStart]="true" startEditAction="click">
            </dxo-editing> -->
            <dxi-column dataField="companyName" caption="Empresa" cellTemplate="companyTemplate"></dxi-column>
            <dxi-column alignment="center" dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate"></dxi-column>
            <!-- <dxi-column dataField="dateScheduled" caption="Fecha" cellTemplate="dateTemplate"></dxi-column> -->
            <!-- <dxi-column dataField="programName" caption="Programa"></dxi-column> -->
            <dxi-column dataField="dispersionAmount" caption="Cantidad" dataType="number" format="currency"
                alignment="center">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="fees" caption="Comisión" dataType="number" format="currency" alignment="center">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="tax" caption="IVA" dataType="number" format="currency" alignment="center">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="granTotal" caption="Total" dataType="number" format="currency" alignment="center">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <!-- <dxi-column dataField="dispersionTypeName" caption="Tipo"></dxi-column> -->
            <dxi-column dataField="status" caption="Status" cellTemplate="status" alignment="center"></dxi-column>
            <dxi-column dataField="id" cellTemplate="btn" caption="" alignment="right"></dxi-column>
            <dxo-summary>
                <dxi-total-item column="companyName" summaryType="count">
                </dxi-total-item>
                <dxi-total-item column="dispersionAmount" summaryType="sum" valueFormat="currency">
                    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
                </dxi-total-item>
                <dxi-total-item column="fees" summaryType="sum" valueFormat="currency">
                    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
                </dxi-total-item>
                <dxi-total-item column="tax" summaryType="sum" valueFormat="currency">
                    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
                </dxi-total-item>
                <dxi-total-item column="granTotal" summaryType="sum" valueFormat="currency">
                    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
                </dxi-total-item>
            </dxo-summary>
            <div *dxTemplate="let c of 'companyTemplate'">
                <div>
                    <i *ngIf="c.data.dispersionPartialId || c.data.isDispersionByError" class="fa fa-project-diagram "></i> 
                    <span>{{ c.value }}</span>
                </div>
            </div>
            <div *dxTemplate="let d of 'dateTemplate'">
                <div> {{d.value|numberToDate}}</div>
            </div>
            <div *dxTemplate="let d of 'status'">
                <span [innerHTML]="d.value|dispersionStatus"> </span>
            </div>
            <div *dxTemplate="let d of 'btn'">
                <a *ngIf="d.data.status === 1 && usdt.level!=7" (click)="aproveDispersion(d.data.id)" class="btn-aprove myPointer">
                    Aprobar</a>
                <a *ngIf="d.data.status === 2" (click)="disaproveDispersion(d.data.id)" class="btn-aprove myPointer">
                    Desaprobar</a>
                <!-- <dx-button *ngIf="d.data.status === 1" icon="check" text="" type="default"
                    (onClick)="aproveDispersion(d.data.id)">
                </dx-button> -->
                <!-- <dx-button *ngIf="d.data.status === 2" icon="clear" text="" type="danger"
                    (onClick)="disaproveDispersion(d.data.id)">
                </dx-button> -->
            </div>
            <div *dxTemplate="let dispDetails of 'detail'">
                <div class="flex flex-nowrap flex-space-between datagrid-detailsW">
                    <div class="mr-5 ml-5">
                        <h2>Detalle de dispersión</h2>
                        <ul>
                            <li>Fecha de creación: {{dispDetails.data.dateCreated|numberToDate}}</li>
                            <li>Fecha programada: {{dispDetails.data.dateScheduled ? (dispDetails.data.dateScheduled|numberToDate) : null}}</li>
                            <li *ngIf="dispDetails.data.dateExecuted">Fecha de ejecución:
                                {{dispDetails.data.dateExecuted|numberToDate}}</li>
                            <li>Número de beneficiarios: {{dispDetails.data.beneficiaries.length}}</li>
                            <li>Programa: {{dispDetails.data.programName}}</li>
                            <li>Tipo de dispersión: {{dispDetails.data.dispersionTypeName}}</li>
                            <li *ngIf="dispDetails.data.recurrance">Recurrencia:
                                {{dispDetails.data.recurrance.name}}</li>
                            <li>ID: {{dispDetails.data.id}}</li>
                        </ul>
                    </div>
                    <div class="mr-5 ml-5">
                        <h2>Detalle de dispersión</h2>
                        <ul>
                            <li>Cantidad a dispersar: {{dispDetails.data.dispersionAmount|currency}}</li>
                            <li>Cantidad dispersada: {{(dispDetails.data.dispersionAmount - dispDetails.data.dispersionAmountPending?dispDetails.data.dispersionAmountPending: 0  )|currency}}</li>
                            <li>Comisión: {{dispDetails.data.fees | currency}}</li>
                            <li>IVA: {{dispDetails.data.tax | currency}}</li>
                            <li>Gran total: {{dispDetails.data.granTotal | currency}}</li>
                        </ul>
                    </div>
                    <div class="mr-5 ml-5 pt-3">
                        <dx-button text="Ver detalle de usuarios" icon="find" type="default"
                            (onClick)="viewDetail(dispDetails.data.id)">
                        </dx-button>
                    </div>
                </div>
            </div>
        </dx-data-grid>
    </div>
</div>

<!-- POPUP  -->
<dx-popup [width]="350" [height]="270" [showTitle]="true" title="Aprobar dispersión" [dragEnabled]="false"
    [closeOnOutsideClick]="false" [(visible)]="popupVisible" [contentTemplate]="currentTemplate">
    <div *dxTemplate="let data of 'notEnoughBalance'">
        <h5 class="aprobe-title">Balance insuficiente?</h5>
        <p>El balance actual de la compañía es {{balanceObj.balance|currency}}</p>
        <p>Balance necesario para la diseprsión {{dispersionAmount|currency}}</p>
        <div class="flex flex-no-wrap flex-space-between mt-3">
            <dx-button text="CANCELAR" type="normal" (onClick)="cancelDispersion()">
            </dx-button>
        </div>
    </div>
    <div *dxTemplate="let data of 'aprove'">
        <h5 class="aprobe-title">Desea aprobar la dispersión?</h5>
        <div class="flex flex-no-wrap flex-space-between flex-align-center mt-3">
            <dx-button text="CANCELAR" type="normal" (onClick)="cancelDispersion()">
            </dx-button>
            <dx-button text="APROBAR" type="default" (onClick)="confirmDispersion()">
            </dx-button>
        </div>
    </div>
    <div *dxTemplate="let data of 'cancel'">
        <h5 class="aprobe-title">Desea cancelar la ejecución de la dispersión?</h5>
        <div class="flex flex-no-wrap flex-space-between flex-align-center mt-3">
            <dx-button text="Z" type="normal" (onClick)="cancelDispersion()">
            </dx-button>
            <dx-button text="DESAPROBAR" type="danger" (onClick)="confirmDisaprobalOfDispersion()">
            </dx-button>
        </div>
    </div>
</dx-popup>